import React, { useEffect, useMemo, useState } from 'react'
import {
    Stepper,
    StepLabel,
    Step,
    StepConnector,
    withStyles,
} from '@material-ui/core'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { NavLink, useLocation } from 'react-router-dom'
import {
    getStepByRoute,
    STEP_SMB_ORDER_FLOW_CONFIRMATION,
    STEP_SMB_ORDER_FLOW_CUSTOMIZE,
    STEP_SMB_ORDER_FLOW_LANDING,
    STEP_SMB_ORDER_FLOW_PLACE_ORDER,
    STEP_SMB_ORDER_FLOW_PRODUCT_DETAILS,
} from '../../../../containers/SMBOrderFlow'
import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    navbarInner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        width: '100%',
    },
    stepper: {
        width: '100%',
        maxWidth: '60%',
        backgroundColor: theme.palette.primary.main,
    },
    cancelLink: {
        color: '#FFFFFF',
        textDecoration: 'none',
        marginRight: '1.5rem',
        border: '1px solid white',
        borderRadius: '5px',
        padding: '0.5rem 1.5rem',
    },
}))

const OrderFlowNavbar = (props) => {
    const classes = useStyles()
    const location = useLocation()
    const [activeStep, setActiveStep] = useState(0)
    const steps = ['Card details', 'Customize', 'Place Order', 'Confirmation']
    const stepByRoute = useMemo(() => getStepByRoute(location.pathname), [
        location.pathname,
    ])

    useEffect(() => {
        switch (stepByRoute) {
            case STEP_SMB_ORDER_FLOW_PRODUCT_DETAILS:
                setActiveStep(0)
                return
            case STEP_SMB_ORDER_FLOW_CUSTOMIZE:
                setActiveStep(1)
                return
            case STEP_SMB_ORDER_FLOW_PLACE_ORDER:
                setActiveStep(2)
                return
            case STEP_SMB_ORDER_FLOW_CONFIRMATION:
                setActiveStep(3)
                return
            default:
                return
        }
    }, [stepByRoute])

    return (
        <div className={classes.root}>
            <div className={classes.navbarInner}>
                <Stepper
                    activeStep={activeStep}
                    alternativeLabel
                    connector={<Connector />}
                    className={classes.stepper}
                >
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={StepIndicator}>
                                {label}
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>
                {stepByRoute !== STEP_SMB_ORDER_FLOW_CONFIRMATION && (
                    <NavLink
                        to={STEP_SMB_ORDER_FLOW_LANDING.route}
                        className={classes.cancelLink}
                    >
                        Cancel
                    </NavLink>
                )}
            </div>
        </div>
    )
}

const Connector = withStyles({
    alternativeLabel: {
        top: '3px',
        width: '100%',
    },
    line: {
        height: 1,
        border: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderRadius: 1,
    },
})(StepConnector)

const stepIndicatorStyles = makeStyles({
    root: {
        width: '125px',
        height: '7px',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderRadius: '7px',
    },
    active: {
        backgroundColor: 'yellow',
    },
    completed: {
        backgroundColor: 'yellow',
    },
})

const StepIndicator = (props) => {
    const classes = stepIndicatorStyles()
    const { active, completed } = props

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        />
    )
}

export default OrderFlowNavbar
